// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as V3DndBehaviour$LiteracyplanetTupperware from "./V3DndBehaviour.res.mjs";

function PilotClozeDragTextContainer(props) {
  return React.createElement(V3DndBehaviour$LiteracyplanetTupperware.Drag.make, {
              id: props.id,
              children: props.children,
              dragClassName: "pilotClozeDragSingleContainer"
            });
}

var make = PilotClozeDragTextContainer;

var $$default = PilotClozeDragTextContainer;

export {
  make ,
  $$default as default,
}
/* react Not a pure module */
